// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mammoth from 'mammoth';

import '../styles/docx.scss';

export default class DocxViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      doc: null,
    };
  }
  componentDidMount() {
    const jsonFile = new XMLHttpRequest();
    jsonFile.open('GET', this.props.filePath, true);
    jsonFile.send();
    jsonFile.responseType = 'arraybuffer';
    jsonFile.onload = () => {
      if (jsonFile.status === 200) {
        mammoth.convertToHtml(
          { arrayBuffer: jsonFile.response },
          { includeDefaultStyleMap: true },
        ).then((result) => {
          const docEl = document.createElement('div');
          docEl.className = 'document-container';
          docEl.innerHTML = result.value;
          this.setState({ ready: true, doc: docEl.outerHTML });
        }).done();
      }
    };
  }

  render() {
    return (
      this.state.ready ?
        // eslint-disable-next-line react/no-danger
        <div id="docx" dangerouslySetInnerHTML={{ __html: this.state.doc }} />
        :
        <this.props.loadingComponent />);
  }
}

DocxViewer.propTypes = {
  filePath: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/FileViewer/drivers/docx-viewer.jsx